import { CreateOrganizationInput, Organization } from "@/types/api"
import http from "@/lib/http/client"

export const createOrganization = async (organization: CreateOrganizationInput): Promise<Organization> => {
  const res = await http.post(`/organizations`, organization)
  return res.data
}

export const switchOrganization = async (organizationId: string): Promise<Organization> => {
  const res = await http.post(`/organizations/${organizationId}/switch`)
  return res.data
}

export const listOrganizations = async (): Promise<Organization[]> => {
  const res = await http.get(`/organizations`)
  return res.data
}

export const deleteOrganization = async (organizationId: string): Promise<void> => {
  const res = await http.delete(`/organizations/${organizationId}`)
  return res.data
}
